const NAME = 'ChannelAuthError';

export class ChannelAuthError extends Error {
  public code?: string;

  constructor(message: string = '', code?: string) {
    super(message);
    this.name = NAME;
    this.message = message;
    this.code = code;
  }
}

export const isChannelAuthError = (error: Error): boolean =>
  error instanceof ChannelAuthError || error?.name === NAME;
